import { db } from './db';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

export const registerUser = async (name: string, email: string) => {
  if (!API_BASE_URL) {
    return null;
  }

  try {
    const response = await fetch(`${API_BASE_URL}/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ name, email }),
    });
    
    if (!response.ok) {
      throw new Error('Failed to register user');
    }
    
    return await response.json();
  } catch (error) {
    console.warn('Backend registration failed (backend might be offline):', error);
    // We don't block the UI if backend is offline
    return null;
  }
};

export const trackMetric = async (event: string, data?: any) => {
  if (!API_BASE_URL) {
    return;
  }

  try {
    const email = await db.getUserEmail();
    
    // Don't track if we don't have an email (unless it's the setup event)
    if (!email && event !== 'app_loaded') return;

    // Use navigator.sendBeacon for better reliability on page unload, 
    // but it requires Blob/FormData/String. fetch is okay for most cases.
    // We'll use fetch with keepalive where supported.
    
    fetch(`${API_BASE_URL}/metrics`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        event,
        data
      }),
      keepalive: true
    }).catch(err => {
      // Silent fail for metrics
      // console.debug('Metric tracking failed:', err);
    });
  } catch (error) {
    // Silent fail
  }
};
